import NoProductsConnector from './noProducts.props';
import NoProductsComponent from './noProducts.component';

export default NoProductsConnector(NoProductsComponent);
